import { Button } from "@dropbox/dig-components/buttons";
import { UIIcon } from "@dropbox/dig-icons";
import { UpsellFill } from "@dropbox/dig-icons/assets";
import { openURL } from "@mirage/service-platform-actions";
import { DASH_PLANS } from "@mirage/shared/urls";
import i18n from "@mirage/translations";

export enum DashTrialCTAButtonVariant {
  PRIMARY,
  SECONDARY,
}
export const DashTrialCTAButton = ({
  variant,
  buttonSize,
}: {
  variant: DashTrialCTAButtonVariant;
  buttonSize: "small" | "medium";
}) => {
  const buttonVariant =
    variant === DashTrialCTAButtonVariant.PRIMARY ? "primary" : "filled";
  return (
    <div>
      <Button
        onClick={() => openURL(DASH_PLANS)}
        variant={buttonVariant}
        withIconStart={<UIIcon src={UpsellFill} />}
        size={buttonSize}
      >
        {i18n.t("view_plans")}
      </Button>
    </div>
  );
};
